import { Component, Prop, h } from '@stencil/core';
import { BusinessDistance, BusinessLease } from '../../types';
import { formatNumber } from '../../utils/helpers';
import state from '../../store';

@Component({
  tag: 'kia-businesslease',
})
export class Priskort {
  @Prop() data: BusinessLease;

  getPrice(distance: BusinessDistance) {
    switch (distance) {
      case BusinessDistance.Two:
        return this.data.s_6000_inkl_forsakring;
      case BusinessDistance.Three:
        return this.data.s_9000_inkl_forsakring;
      case BusinessDistance.Four:
        return this.data.s_12000_inkl_forsakring;
      default:
        return this.data.s_4500_inkl_forsakring;
    }
  }

  render() {
    return (
      <div class="kia_price_card--module">
        <h5>
          Business Lease garanterat restvärde ⁵<kia-tooltip toolTitle="Inkl. serviceavtal, försäkring, vinterhjul, 36 mån, ex.moms" />
        </h5>
        <p>Från {formatNumber(this.getPrice(state.businessDistance))} kr/mån</p>
        <p>(Första förhöjd hyra {this.data.andra_i_nedan_cell_1a_hyra_i}%)</p>
      </div>
    );
  }
}
